export default __webpack_public_path__ + "static/media/login_img.7917db78.png";